import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import JsZip from 'jszip'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver';
import PageTracker from '../../../../common/PageTrackerHelper'


export default {
  name: 'ePaymentTransactionsForShipment',
  components: {
      VueElementLoading,
      Paginate,
      JsZip
  },
  mixins:[PageTracker],
  data: function() {
      return {
       Loading: false,
       localuserid:'',
       localusermailid:'',
       rolename:'',
       OutSourcingMasterId:'',
       Status:'0',
       ShippingID:'',
       shipmentData:[],
       checkCount: null,
       isLoading:false,
       ReturnMessage:'',
       userDataKey : '',
      }
  },
  created: function() {},
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    console.log('userdetail',userdetail);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.rolename = userdetail.userrole[0]['rolename'];
    this.hubname = userdetail.hubdetails[0];
    this.OutSourcingMasterId = userdetail.outsourcingid;

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    //console.log('Mixin is working for :',result);
  },
  methods : {
    // changeDateFormat(inputString){
    //   let current_datetime = new Date(inputString)
    //   let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
    //   return formatted_date;
    // },
    getShipmentdetailsbyshippingid(){
     this.$validator.validateAll().then(result => {
       if(this.ShippingID){

         let serchData = {
            "ShippingID":(this.ShippingID).trim(),
            "HubID" : (this.hubname).toString().trim()//212
          }
          this.ReturnMessage = ''
          this.shipmentData = []
          this.isLoading = true;
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'external/GetE_PaymentTransactionsForShipment',
              'data': serchData
          })
          .then(async result => {
            this.checkCount = null
            this.ReturnMessage = ''
            if(result.data.code == 200){
               this.checkCount ='1'
               this.shipmentData = result.data.data
               this.isLoading = false;
            }else{
                this.checkCount ='2'
                this.ReturnMessage = result.data.message
                this.shipmentData = []
                this.isLoading = false;
            }

          })
       }
     })
    },
    reset(){
    this.ShippingID =''
    this.checkCount = null
    this.ReturnMessage = ''
    this.shipmentData = {}
    this.isLoading = false;
    }

  }
}

Validator.extend('verify_shipments', {
  getMessage: field => "Invalid ShippingId. Please Enter valid shippingID",
  validate: value => {
      var ShippingID = $("#ShippingID").val();
      let flag=0;
      if(isNaN(ShippingID) || (ShippingID.length<3)){
        flag=1;
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/E_PaymentTransactionDetails/ePaymentTransactionsForShipment/ePaymentTransactionsForShipment.component.js